import { once } from "~/jose_modern/once.js";
import { scanTruncatedElements } from "./truncation.js";

/**
 * Initialize visibility toggle functionality for show/hide UI patterns.
 *
 * Works with elements having:
 * - data-visibility-toggle-content - the content to show/hide
 * - data-visibility-toggle="show" - button or link to show content
 * - data-visibility-toggle="hide" - button or link to hide content
 * - (optional) data-record-is-empty="true|false" - indicates if the record is empty
 */
export function updateVisibility(visible, onVisibilityChange = null) {
  const section = document.querySelector("[data-visibility-toggle-content]");
  if (!section) return visible;

  const effectiveVisibility = visible;

  if (onVisibilityChange) {
    onVisibilityChange(effectiveVisibility);
  }

  document.querySelectorAll('[data-visibility-toggle="hide"]').forEach((el) => {
    el.classList.toggle("is-hidden", !effectiveVisibility);
  });

  document.querySelectorAll('[data-visibility-toggle="show"]').forEach((el) => {
    el.classList.toggle("is-hidden", effectiveVisibility);
  });

  document.querySelectorAll("[data-visibility-toggle-content]").forEach((el) => {
    el.classList.toggle("is-hidden", !effectiveVisibility);

    if (effectiveVisibility && !el.classList.contains("is-hidden")) {
      requestAnimationFrame(() => scanTruncatedElements(el));
    }
  });

  return effectiveVisibility;
}

export function initializeVisibilityToggle(onVisibilityChange = null) {
  once(document, "visibility-toggle", (doc) => {
    doc.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-visibility-toggle]");
      if (!trigger) return;

      const action = trigger.dataset.visibilityToggle;
      if (action === "show" || action === "hide") {
        event.preventDefault();

        updateVisibility(action === "show", onVisibilityChange);
      }
    });
  });
}
